/*
 * This is the entry point to the forked build processes
 */

import { configureWebpack } from "@excitare/cli-config-webpack";
import { PubSubClient, PubSubEvents } from "@excitare/pubsub";
import { dirname, join, relative } from "path";
import webpack from "webpack";

if (process.env.SERVER_ID == null) {
  throw new Error("process.env.SERVER_ID must not be null or undefined");
}

if (process.env.ENTRY == null) {
  throw new Error("process.env.ENTRY must not be null or undefined");
}
if (process.env.OUTPUT_DIRECTORY == null) {
  throw new Error("process.env.OUTPUT_DIRECTORY must not be null or undefined");
}
if (process.env.OUTPUT_NAME == null) {
  throw new Error("process.env.OUTPUT_NAME must not be null or undefined");
}
if (process.env.NAME == null) {
  throw new Error("process.env.NAME must not be null or undefined");
}
if (process.env.EXTERNALS == null) {
  throw new Error("process.env.EXTERNALS must not be null or undefined");
}
if (process.env.BUNDLE_OPTIONS == null) {
  throw new Error("process.env.BUNDLE_OPTIONS must not be null or undefined");
}

const pubsubClient = new PubSubClient(process.env.SERVER_ID);

function reviver(_key: any, value: any) {
  if (value != null && value.toString().indexOf("__REGEXP ") === 0) {
    const m = value.split("__REGEXP ")[1].match(/\/(.*)\/(.*)?/);
    return new RegExp(m[1], m[2] || "");
  } else {
    return value;
  }
}

const compiler = webpack(
  configureWebpack("development", process.env.TYPE as any, {
    context: join(__dirname, "../../"),
    entry: process.env.ENTRY,
    outputDir: process.env.OUTPUT_DIRECTORY,
    outputName: process.env.OUTPUT_NAME,
    name: process.env.NAME,
    rootDir: process.cwd(),
    externals: JSON.parse(process.env.EXTERNALS) as string[],
    bundleOptions: JSON.parse(process.env.BUNDLE_OPTIONS, reviver),
    iconOptions:
      process.env.ICON_OPTIONS != null ? JSON.parse(process.env.ICON_OPTIONS, reviver) : null
  })
);

function handleWebpackOutput(err: any, stats: webpack.Stats, onDone: (errors?: Error[]) => void) {
  if (err && err != null && err !== "null") {
    console.error(err);
    return onDone([err]);
  } else if (stats.hasErrors() && stats.compilation.errors != null) {
    console.error(stats.compilation.errors);
    return onDone(
      stats.compilation.errors.map((compilationError: any) => {
        return {
          ...compilationError,
          module: null,
          origin: null
        };
      })
    );
  }
  console.info(stats.toString("minimal"));
  onDone();
}

function webpackWatch(
  onStarted: (changedFiles: string[]) => void,
  onDone: (errors?: Error[]) => void
) {
  compiler.hooks.watchRun.tap("plugin name", _compiler => {
    const changedTimes = (_compiler as any).watchFileSystem.watcher.mtimes;
    onStarted(Object.keys(changedTimes) as string[]);
  });
  compiler.watch(
    {
      aggregateTimeout: 100,
      ignored: [
        "**/excitare/cli/modules/cli-config-webpack/**",
        "**/excitare/packages/entry-next/**",
        /\.map$/,
        /\.d\.ts$/,
        /\.d\.ts\.map$/,
        /\.d\.tsx$/,
        /\.jsx$/,
        /[\\\/]node_modules[\\\/]/,
        /[\\\/]\.next[\\\/]/,
        /[\\\/]\.excitare[\\\/]/,
        /[\\\/]\.excitare-dev[\\\/]/
      ]
    },
    (err, stats) => {
      handleWebpackOutput(err, stats, onDone);
    }
  );
}

function watch(onStarted: (changedFiles: string[]) => void, onDone: (errors?: Error[]) => void) {
  console.log("Watching %s", process.env.NAME);

  let resolved = false;
  return new Promise<any>(resolve => {
    webpackWatch(onStarted, errors => {
      if (!resolved) {
        resolved = true;
        process.nextTick(() => {
          if (errors) {
            resolve(errors);
          }
          resolve({});
        });
      }
      onDone(errors);
    });
  });
}

watch(
  changedFiles => {
    if (process.env.NAME == null) {
      throw new Error("process.env.NAME must not be null or undefined");
    }

    for (const file of changedFiles) {
      console.log(`[watcher] ${relative(dirname(process.env.ENTRY!), file)} changed`);
    }
    if (changedFiles.length === 0) {
      console.log(`[watcher] no files changed, but restarting anyways`);
    }

    pubsubClient.emit(PubSubEvents.BuildStatus, {
      name: process.env.NAME,
      type: "started",
      changedFiles
    });
  },
  errors => {
    if (process.env.NAME == null) {
      throw new Error("process.env.NAME must not be null or undefined");
    }

    if (errors) {
      console.log("Webpack build failed!");
      pubsubClient.emit(PubSubEvents.BuildStatus, {
        name: process.env.NAME,
        type: "failure",
        errors: errors.map(err => err.message)
      });
    } else {
      console.log("Webpack build succeeded!");
      pubsubClient.emit(PubSubEvents.BuildStatus, {
        name: process.env.NAME,
        type: "successful"
      });
    }
  }
);
